
import { Button, Box } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { useParams, Navigate } from "react-router-dom";

export const DownDetectorPageSelect = () => {
  const { dashboard: pDashboard } = useParams();
  const { pathname } = useLocation();

  const path = pathname.split("/").filter((x) => x).pop();

  let navigate = useNavigate()

  const handlePageSelect = (path) => {
      navigate(path);
  };

  return (
    <Box sx={{ flexGrow: 1, justifyContent: 'right', mr: 4, display: { xs: 'none', md: 'flex' } }}>
      <Button
        onClick={() => handlePageSelect(`/downdetector/dashboard`)}
        sx={{ color: 'white', display: 'block', fontWeight: path === pDashboard ? 'bold' : '' }}
      >
        Dashboard
      </Button>

      <Button
        onClick={() => handlePageSelect(`/downdetector/upload`)}
        sx={{ color: 'white', display: 'block', fontWeight: path === "summary" ? 'bold' : '' }}
      >
        Upload
      </Button>
    </Box>
  );
};